import styled from 'styled-components';
import {Space} from 'antd';

const StyledBudgetDetailsForm = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

const StyledBudgetDetailsFormContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  form {
    max-width: 300px;
  }
  .ant-space-item {
    display: flex;
    input, .ant-select > * {
      font-size: 14px;
    }
  }

  .ant-form-item-label label {
    font-weight: 500;
  }
`;

const StyledBudgetDetailsFormSpace = styled(Space)`
  width: 100%;
  & > div {
    width: 50%;
  }

  .ant-form-item {
    width: 100%;
    margin-bottom: 16px;
  }
`;

export {
  StyledBudgetDetailsForm,
  StyledBudgetDetailsFormContainer,
  StyledBudgetDetailsFormSpace
}
